<template>
  <v-card>
    <div class="title-top">
      <v-card-title class="headline float-left">
        {{ currentWidgetTitle }}
      </v-card-title>
    </div>

    <v-card-text>
      <v-form v-if="showForm">
        <v-form-base :value="widgetValues" :schema="widgetSchema" />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn color="indigo lighten-4" text @click="closeDialog">
        {{ $t('dialogs.editWidget.btnDismiss') }}
      </v-btn>

      <v-btn color="green lighten-1" text @click="updateTheStore">
        {{ $t('dialogs.editWidget.btnUpdate') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import VFormBase from 'vuetify-form-base'

export default {
  name: 'WidgetForm',
  components: {
    VFormBase
  },
  props: {
    widgetSchema: {
      type: Object,
      required: false
    },
    widgetValues: {
      type: Object,
      required: false
    },
    widgetName: {
      type: String,
      required: true
    },
    widgetPosition: {
      type: String,
      required: true
    },
    showForm: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      editTitle: null
    }
  },
  computed: {
    currentWidgetTitle() {
      const transWidgetName = `dialogs.editWidget.${this.widgetName}`
      return this.$t(transWidgetName)
    }
  },
  methods: {
    updateTheStore() {
      const updates = [this.widgetName, this.widgetValues]
      const payload = {}
      payload.widgetName = this.widgetName
      payload.widgetContents = this.widgetValues
      this.$store.dispatch('dashboard/updateWidgetDataFromDialog', {
        updates
      })
      this.closeDialog('submit')
    },
    closeDialog() {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
.remove-btn {
  padding-top: 10px;
}
</style>
